const achievementType = {
  BADGE       : 1,
  CERTIFICATE : 2
};

const getAchievementTypeTitle = (typeId) => {
  return {
    [achievementType.BADGE]       : "badge",
    [achievementType.CERTIFICATE] : "certificate"
  }[typeId];
};

const getTranslatedAchievementTypeName = (typeId) => {
  return {
    [achievementType.BADGE]       : window.$nuxt.$t('achievements.typeBadge').toLowerCase(),
    [achievementType.CERTIFICATE] : window.$nuxt.$t('achievements.typeCertificate').toLowerCase()
  }[typeId];
};

const achievementFilters = {
  ALL        : 'all',
  TO_CONQUER : 'toConquer',
  CONQUERED  : 'conquered'
};

export {
  achievementType,
  getAchievementTypeTitle,
  getTranslatedAchievementTypeName,
  achievementFilters
};